$(document).ready(function(){

	// -- slider default --
	$('.slider__default').each(function(index, value) {
		var sliderDefaultSettings = {
		  infinite: false,
		  slidesToShow: 2,
		  slidesToScroll: 1,
		  dots: false,
		  arrows: true,
		  prevArrow: $(this).prev().find('.prev__slide'),
		  nextArrow: $(this).prev().find('.next__slide'),
			responsive: [{
			breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				}
			}]
		}
		$(this).on('init breakpoint', function(event, slick){
		  if ($(window).width() < 1024) {
		  	$(this).prev().find('.slider__position .total').text(slick.slideCount);
		  } else {
		  	$(this).prev().find('.slider__position .total').text(Math.round(slick.slideCount/2));
		  }
		});
		$(this).on('afterChange', function(event, slick, currentSlide, nextSlide){
			$(this).prev().find('.slider__position .current').text(currentSlide+1);
		});
		$(this).slick(sliderDefaultSettings);
	});


	// -- slider vertical --
	var sliderVertical = $('.slider__vertical');
	var sliderVerticalSettings = {
	 	autoplay: true,
  	autoplaySpeed: 6000,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  slide: '.slick-slide',
	  arrows: false,
	  dots: false,
	  vertical: true,
	  verticalSwiping: true,
	  pauseOnHover: false,
	  pauseOnFocus: false,
	  pauseOnDotsHover: false,
	}
  $('.btn--goTo').on('click', function(){
  	var index = $(this).attr('data-index');
  	sliderVertical.slick('slickGoTo', index);
  });
	sliderVertical.on('afterChange', function(event, slick, currentSlide, nextSlide){
		$('.btn--goTo').parent('li').removeClass('active');
		$('.btn--goTo').removeClass('text-family');
		$('.btn--goTo[data-index="'+currentSlide+'"]').parent('li').addClass('active');
		$('.btn--goTo[data-index="'+currentSlide+'"]').addClass('text-family');
	});
	sliderVertical.on('setPosition', function (event, slick) {
    let slideHeight = slick.$slider.outerHeight();
    document.querySelector(':root').style.setProperty('--vertical-slider-height', slideHeight+ 'px');
	});
  sliderVertical.slick(sliderVerticalSettings);

  
	// -- slider addresses --
	var sliderAddresses = $('.slider__addresses');
	var sliderAddressesSettings = {
	 	autoplay: false,
	  infinite: false,
	  slidesToShow: 1,
	  slidesToScroll: 1,
    adaptiveHeight: true,
	  dots: false,
	  arrows: true,
	  prevArrow: sliderAddresses.prev().find('.prev__slide'),
	  nextArrow: sliderAddresses.prev().find('.next__slide'),
	  mobileFirst: true,
		responsive: [{
		breakpoint: 768,
			settings: "unslick"
		}]	  
	};
	sliderAddresses.on('afterChange', function(event, slick, currentSlide){
		event.preventDefault();
		sliderAddresses.prev().find('.slider__position .current').text(currentSlide+1);
		var id = $(`[data-slick-index="${currentSlide}"] .card--address`).attr('id');
		var marker = $(`.marker[data-id="${id}"]`);
		if (!marker.hasClass('active')) {
			$(`.marker[data-id="${id}"]`).click();
		}
	});
  sliderAddresses.slick(sliderAddressesSettings);

});